import React, { useState, useEffect, useRef } from "react";
import { Bell } from "react-feather";
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from "sweetalert2";

const SellerNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const cust_id = localStorage.getItem("seller_id");
  const user_type = 'seller'; // 'user' or 'seller'
  const dropdownRef = useRef();

  // Fetch notifications from API
  const fetchNotifications = async () => {
    if (!cust_id) return;

    try {
      const response = await axios.get(
        `${baseurl}getUserNotifications/${cust_id}`
      );
      if (response.data.success) {
        setNotifications(response.data.notifications);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
      Swal.fire("Error", "Failed to fetch notifications", "error");
    }
  };

  // Mark notifications as read
  const markAllAsRead = async () => {
    if (!cust_id || !user_type) return;

    try {
      await axios.put(`${baseurl}markNotificationsRead/${cust_id}/${user_type}`);
      // Update local state to reflect read notifications
      setNotifications((prev) =>
        prev.map((n) => ({ ...n, is_read: true }))
      );
    } catch (err) {
      console.error("Error marking notifications as read:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [cust_id]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    if (!dropdownOpen) {
      // If opening dropdown, mark all unread notifications as read
      markAllAsRead();
    }
  };

  // ------------------- INLINE CSS -------------------
  const styles = {
    wrapper: { position: "relative", display: "inline-block" },
    bellIcon: { position: "relative", cursor: "pointer", color: "#000" },
    notificationDot: {
      position: "absolute",
      top: 0,
      right: 0,
      width: 8,
      height: 8,
      backgroundColor: "red",
      borderRadius: "50%",
      border: "1px solid #fff",
    },
    dropdown: {
      position: "absolute",
      right: 0,
      top: 30,
      width: 300,
      maxHeight: 400,
      overflowY: "auto",
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: 5,
      boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
      zIndex: 1000,
    },
    header: {
      padding: "8px 12px",
      fontWeight: "bold",
      borderBottom: "1px solid #ddd",
      backgroundColor: "#f5f5f5",
    },
    item: {
      padding: "10px 12px",
      borderBottom: "1px solid #eee",
      fontSize: 14,
    },
    unread: { backgroundColor: "#eef6ff" },
    title: { fontWeight: 600 },
    message: { margin: "4px 0", color: "#555" },
    time: { fontSize: 12, color: "#888", textAlign: "right" },
    noNotification: { textAlign: "center", padding: 10, color: "#555" },
  };

  return (
    <div style={styles.wrapper} ref={dropdownRef}>
      <div style={styles.bellIcon} onClick={toggleDropdown}>
        <Bell size={20} />
        {notifications.some((n) => !n.is_read) && (
          <span style={styles.notificationDot}></span>
        )}
      </div>

      {dropdownOpen && (
        <div style={styles.dropdown} className="text-start">
          <h6 style={styles.header}>Notifications</h6>
          {notifications.length > 0 ? (
            notifications.map((n) => (
              <div
                key={n.id}
                style={{ ...styles.item, ...(n.is_read ? {} : styles.unread) }}
              >
                <div style={styles.title}>{n.title}</div>
                <div style={styles.message}>{n.message}</div>
                <div style={styles.time}>
                  {new Date(n.created_at).toLocaleDateString()}
                </div>
              </div>
            ))
          ) : (
            <div style={styles.noNotification}>No notifications</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SellerNotification;
